// extracted by mini-css-extract-plugin
module.exports = {"headBar":"Head_headBar__3uFDN","logoWrapper":"Head_logoWrapper__H0m5i"};